import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

type QueryProviderProps = {
	children: React.ReactNode;
};

const queryClient = new QueryClient();

export const QueryProvider = ({
	children,
}: QueryProviderProps): JSX.Element => (
	<QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);
